export const enum Actions {
  Selected = 'SELECT_ITEM',
}
